import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  websiteSelectedDoctorName: null,
};

const websiteReferrerSlice = createSlice({
  name: 'websiteReferrer',
  initialState,
  reducers: {
    setWebsiteDoctorName: (state, action) => {
      state.websiteSelectedDoctorName = action.payload;
    },
    clearWebsiteDoctorName: (state) => {
      state.websiteSelectedDoctorName = null;
    },
  },
});

export const { setWebsiteDoctorName, clearWebsiteDoctorName } = websiteReferrerSlice.actions;

export default websiteReferrerSlice;